import React from 'react';
import Modal from './Modal';
import Button from './Button';
import './ErrorDialog.css';

const ErrorDialog = ({
  isOpen,
  onClose,
  title = 'Error',
  message = 'An error occurred',
  buttonText = 'OK',
  variant = 'error',
  size = 'small'
}) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={size}
      closeOnOverlayClick={true}
      className="error-dialog-modal"
    >
      <div className="error-dialog">
        <div className="error-dialog-header">
          <div className="error-dialog-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
          </div>
          <h3 className="error-dialog-title">{title}</h3>
        </div>
        <div className="error-dialog-content">
          <p className="error-dialog-message">{message}</p>
        </div>
        <div className="error-dialog-actions">
          <Button
            variant="primary"
            onClick={handleClose}
            className="error-dialog-button"
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ErrorDialog;

